module.exports = __webpack_public_path__ + "img/footer_brilliant.d7eb14af.png";